<!-- <h4 class="h4">(Personnel)</h4> -->
<div class="main-content mt-0">
  <div class="container-fluid p-0">
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Campo de búsqueda mejorado con autocompletado -->
    <div class="row mb-3">
      <div class="col-md-4">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search ..."
            [(ngModel)]="searchText"
            (ngModelChange)="filterInfo()"
            list="suggestions"
            autocomplete="off"
          />
          <span class="input-group-text bg-transparent"
            ><i class="fas fa-search text-dark"></i
          ></span>
          <datalist id="suggestions">
            <option
              *ngFor="let sugerencia of sugerenciasBusqueda"
              [value]="sugerencia"
            ></option>
          </datalist>
        </div>
      </div>
    </div>

    <div class="card-tools">
      <a
        class="btn btn-dark btn-sm btn-new"
        [routerLink]="['/humanResources']"
        [ngClass]="{ 'btn-selected': step === 1 }"
      >
        Staff
      </a>
      <a
        class="btn btn-dark btn-sm btn-new"
        [routerLink]="['/humanResources/freelancers']"
        [ngClass]="{ 'btn-selected': step === 2 }"
      >
        Freelancers
      </a>
      <a
        [routerLink]="['/humanResources/drivers']"
        class="btn btn-dark btn-sm btn-new"
        [ngClass]="{ 'btn-selected': step === 3 }"
      >
        Driver & +
      </a>
      <a
        [routerLink]="['/humanResources/customers']"
        class="btn btn-dark btn-sm btn-new"
        [ngClass]="{ 'btn-selected': step === 4 }"
      >
        Customers
      </a>
    </div>

    <div class="row">
      <div class="col-md-9">
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <!--  <i class="material-icons">perm_identity</i> -->
              <img
                class="img--icon"
                [src]="userImgUrl"
                (click)="openModalImg('imgUser')"
              />
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              {{ id ? "Profile: " + fullname : "New Personnel" }}
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->

              <br />
              <div class="row mb-6 justify-content-center">
                <div class="col-md-12 text-center">
                  <!-- class="btn btn-dark btn-sm btn-step" -->
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 1,
                    'btn-step__selected': step === 1,
                  }"
                    (click)="changeStep(1)"
                  >
                    Profile
                  </a>
                  <a
                    [ngClass]="{
                      btn: true,
                      'btn-sm': true,
                      'btn-dark': true,
                      'btn-step': step !== 2,
                      'btn-step__selected': step === 2,
                    }"
                    (click)="changeStep(2)"
                  >
                    Compliance
                  </a>
                  <a
                    *ngIf="step == 1"
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 3,
                    'btn-step__selected': step === 3,
                  }"
                    (click)="changeStep(3)"
                  >
                    Availability
                  </a>
                  <a
                    *ngIf="step == 1"
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 4,
                    'btn-step__selected': step === 4,
                  }"
                    (click)="changeStep(4)"
                  >
                    Evaluation
                  </a>
                  <a
                    *ngIf="step == 1"
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 5,
                    'btn-step__selected': step === 5,
                  }"
                    (click)="changeStep(5)"
                  >
                    Salary
                  </a>
                </div>
              </div>
              <br />

              <!-- Profile -->
              <div class="row" *ngIf="step == 1">
                <div class="col-12">
                  <h4 class="title">Profile</h4>
                </div>
                <div class="row row_data">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="firstname"
                        >Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="firstname"
                        formControlName="firstname"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('firstname')"
                      >
                        The name is required
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="lastname"
                        >Last Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="lastname"
                        formControlName="lastname"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('lastname')"
                      >
                        The last name is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->

                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="identification"
                        >Identification</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="identification"
                        formControlName="identification"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('identification')"
                      >
                        The identification number is required
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="rut"
                        >S.S / RUT</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="rut"
                        formControlName="rut"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('rut')"
                      >
                        The RUT is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="username"
                        >Email</label
                      >
                      <div class="d-flex">
                        <input
                          type="text"
                          class="form-control"
                          id="username"
                          formControlName="username"
                          [readOnly]="!update"
                        />
                        <button
                          class="btn btn-sm btn-outline-dark"
                          type="button"
                          (click)="openEmail(form.get('username')?.value)"
                          title="Send email"
                        >
                          <i class="fas fa-envelope"></i>
                        </button>
                        <div
                          class="invalid-feedback"
                          *ngIf="isFieldInvalid('username')"
                        >
                          The email is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="title"
                        >Title</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="title"
                        formControlName="title"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('title')"
                      >
                        The title is required
                      </div>
                    </div>
                  </div>
                  <div class="col-5 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="indicative"
                        >Indicative</label
                      >
                      <select
                        class="form-control select"
                        id="indicative"
                        formControlName="indicative"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="" disabled>Select a indicative</option>
                        <option *ngFor="let item of indicatives" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('indicative')"
                      >
                        Indicative is required
                      </div>
                    </div>
                  </div>
                  <div class="col-7 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="phone"
                        >Phone</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        formControlName="phone"
                        (input)="formatPhone($event)"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('phone')"
                      >
                        The phone is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="address"
                        >Address</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        formControlName="address"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('address')"
                      >
                        The address is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="apt">Apt</label>
                      <input
                        type="text"
                        class="form-control"
                        id="apt"
                        formControlName="apt"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="city">City</label>
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        formControlName="city"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('city')"
                      >
                        City is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="state"
                        >State</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="state"
                        formControlName="state"
                        [readOnly]="!update"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('state')"
                      >
                        State is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="country"
                        >Country</label
                      >
                      <select
                        class="form-control select"
                        id="country"
                        formControlName="country"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="" disabled>Select a country</option>
                        <option *ngFor="let item of countries" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('country')"
                      >
                        Country is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="role">Role</label>
                      <select
                        class="form-control select"
                        id="role"
                        formControlName="role"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="">Select a role</option>
                        <option *ngFor="let item of roles" [value]="item._id">
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('role')"
                      >
                        The role is required
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="department"
                        >Department</label
                      >
                      <select
                        class="form-control select"
                        id="department"
                        formControlName="department"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="">Select a department</option>
                        <option *ngFor="let item of departments" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('department')"
                      >
                        The department is required
                      </div>
                    </div>
                  </div>
                  <!-- </div>
  
                <div class="row"> -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <div
                        class="custom-control custom-switch mt-4 text-center"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="status"
                          formControlName="status"
                          [readOnly]="!update"
                        />
                        <label class="custom-control-label" for="status"
                          >Active</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Compliance -->
              <div class="row" *ngIf="step == 2">
                <div class="col-12">
                  <h4 class="title">Compliance</h4>
                </div>
                <div class="row row_data" formGroupName="compliance">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="startContract"
                        >Contract signing date</label
                      >
                      <input
                        type="date"
                        class="form-control"
                        id="startContract"
                        formControlName="startContract"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="endContract"
                        >Expiration date</label
                      >
                      <input
                        type="date"
                        class="form-control"
                        id="endContract"
                        formControlName="endContract"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="verifiedBy"
                        >Verified by</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="verifiedBy"
                        formControlName="verifiedBy"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="background"
                        >Background</label
                      >
                      <select
                        class="form-control select"
                        id="background"
                        formControlName="background"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="" disabled>Select a background</option>
                        <option *ngFor="let item of backgrounds" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('background')"
                      >
                        The background is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <a class="d-block a__activity">Activity Log</a>
                    </div>
                  </div>

                  <div class="col-6 col-md-12 div__center--btns">
                    <div class="form-group">
                      <a
                        (click)="contractUrl()"
                        [href]="contractLink"
                        target="_blank"
                        class="viewDocs btn btn-sm"
                        *ngIf="id"
                        >Contract</a
                      >
                      <a
                        (click)="selectFile('fileInput')"
                        *ngIf="!id"
                        [class.disabled]="uploadStatus.contract"
                        [style.pointer-events]="
                          uploadStatus.contract ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.contract ? '0.5' : '1'"
                        style="cursor: pointer"
                      >
                        Select contract
                        <input
                          #fileInput
                          type="file"
                          (change)="
                            captureFile(
                              $event,
                              'contract',
                              'contract',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                          [readOnly]="!update"
                        />
                      </a>
                      <span *ngIf="uploadStatus.contract"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.contract"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFile('contract', 'contract', 'compliance')
                        "
                      >
                        X
                      </button>
                    </div>
                    <div class="form-group">
                      <a
                        (click)="ndaUrl()"
                        [href]="ndaLink"
                        target="_blank"
                        class="viewDocs btn btn-sm"
                        *ngIf="id"
                        >NDA</a
                      >
                      <a
                        (click)="selectFile('fileInputTwo')"
                        *ngIf="!id"
                        [class.disabled]="uploadStatus.nda"
                        [style.pointer-events]="
                          uploadStatus.nda ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.nda ? '0.5' : '1'"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select NDA
                        <input
                          #fileInputTwo
                          type="file"
                          (change)="
                            captureFile($event, 'nda', 'nda', 'compliance')
                          "
                          style="display: none"
                          accept="application/pdf"
                          [readOnly]="!update"
                        />
                      </a>
                      <span *ngIf="uploadStatus.nda"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.nda"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="removeFile('nda', 'nda', 'compliance')"
                      >
                        X
                      </button>
                    </div>

                    <div class="form-group">
                      <!-- (click)="licensesMedicalUrl()"
                        [href]="licensesMedicalLink"
                        target="_blank" -->
                      <a
                        (click)="openModal()"
                        class="viewDocs btn btn-sm a__modal"
                        *ngIf="id"
                        >Sick leave</a
                      >
                    </div>
                  </div>

                  <div class="col-6 col-md-12 div__center--btns">
                    <div class="form-group">
                      <a
                        (click)="insuranceUrl()"
                        [href]="insuranceLink"
                        target="_blank"
                        class="viewDocs btn btn-sm"
                        *ngIf="id"
                        >Insurance</a
                      >
                    </div>

                    <div class="form-group">
                      <a
                        class="viewDocs btn btn-sm"
                        (click)="selectFile('fileInputFour')"
                        [class.disabled]="uploadStatus.insurance"
                        [style.pointer-events]="
                          uploadStatus.insurance ? 'none' : 'auto'
                        "
                        [style.opacity]="uploadStatus.insurance ? '0.5' : '1'"
                        style="cursor: pointer"
                      >
                        <!-- text-decoration: underline;
                          color: #007bff; -->
                        Select insurance
                        <input
                          #fileInputFour
                          type="file"
                          (change)="
                            captureFile(
                              $event,
                              'insurance',
                              'insurance',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                          [readOnly]="!update"
                        />
                      </a>
                      <span *ngIf="uploadStatus.insurance"> (Uploaded) </span>
                      <button
                        *ngIf="uploadStatus.insurance"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFile('insurance', 'insurance', 'compliance')
                        "
                      >
                        X
                      </button>
                    </div>

                    <div class="form-group">
                      <!-- (click)="licensesMedicalUrl()"
                        [href]="licensesMedicalLink"
                        target="_blank" -->
                      <a
                        class="viewDocs btn btn-sm"
                        (click)="selectFile('fileInputThree')"
                        [class.disabled]="uploadStatus.licensesMedical"
                        [style.pointer-events]="
                          uploadStatus.licensesMedical ? 'none' : 'auto'
                        "
                        [style.opacity]="
                          uploadStatus.licensesMedical ? '0.5' : '1'
                        "
                        style="cursor: pointer"
                      >
                        Select sick leave
                        <input
                          #fileInputThree
                          type="file"
                          (change)="
                            captureFile(
                              $event,
                              'licensesMedical',
                              'licenses',
                              'compliance'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                          [readOnly]="!update"
                        />
                      </a>
                      <span *ngIf="uploadStatus.licensesMedical">
                        (Uploaded)
                      </span>
                      <button
                        *ngIf="uploadStatus.licensesMedical"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFile(
                            'licensesMedical',
                            'licenses',
                            'compliance'
                          )
                        "
                      >
                        X
                      </button>
                    </div>
                  </div>

                  <!-- Modal licenses medical-->
                  <div
                    class="modal fade"
                    tabindex="-1"
                    [ngClass]="{ 'show d-block': showModal }"
                    style="background-color: rgba(0, 0, 0, 0.5)"
                  >
                    <!-- style="background-color: rgba(0,0,0,0.5);" -->
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header modal-close">
                          <button
                            type="button"
                            class="btn btn-link btn-sm btn-close"
                            (click)="closeModal()"
                          >
                            &times;
                          </button>
                        </div>
                        <div class="modal-body text-center">
                          <div
                            class="row row_data"
                            formArrayName="licenses"
                            *ngFor="
                              let license of licenses.controls;
                              let i = index
                            "
                          >
                            <div class="col-md-6">
                              <div class="form-group">
                                <!-- <span>{{ license.value }}</span> -->
                                ({{ i + 1 }})
                                <a
                                  (click)="licensesMedicalUrl(license.value)"
                                  [href]="licensesMedicalLink"
                                  target="_blank"
                                  class="viewDocs btn btn-sm"
                                  >{{ license.value }}</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  -->
              </div>

              <!-- availability -->
              <div class="row" *ngIf="step == 3">
                <div class="col-12">
                  <h4 class="title">Availability</h4>
                </div>
                <div class="row row_data" formGroupName="availability">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="workingDays"
                        >Working days</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="workingDays"
                        formControlName="workingDays"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="modality"
                        >Modality</label
                      >
                      <select
                        class="form-control select"
                        id="modality"
                        formControlName="modality"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="" disabled>Select a modality</option>
                        <option *ngFor="let item of modalities" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('modality')"
                      >
                        Modality is required
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="schedule"
                        >Assigned schedule</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="schedule"
                        formControlName="schedule"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="ticketRegistration"
                        >Check-in/check-out log</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="ticketRegistration"
                        formControlName="ticketRegistration"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="recordedAbsences"
                        >Recorded absences</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="recordedAbsences"
                        formControlName="recordedAbsences"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="vacation"
                        >Vacation</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="vacation"
                        formControlName="vacation"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="licenses"
                        >Leaves of absence</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="licenses"
                        formControlName="licenses"
                      />
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <a
                        (click)="licensesLeaveUrl()"
                        [href]="licensesLeaveLink"
                        target="_blank"
                        class="viewDocs btn btn-sm"
                        *ngIf="id"
                        >Leaves of absence</a
                      >
                      <a
                        (click)="selectFile('fileInputFive')"
                        [class.disabled]="uploadStatus.licensesLeave"
                        [style.pointer-events]="
                          uploadStatus.licensesLeave ? 'none' : 'auto'
                        "
                        [style.opacity]="
                          uploadStatus.licensesLeave ? '0.5' : '1'
                        "
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          color: #007bff;
                        "
                      >
                        Select leaves of absence
                        <input
                          #fileInputFive
                          type="file"
                          (change)="
                            captureFile(
                              $event,
                              'licensesLeave',
                              'licenses',
                              'availability'
                            )
                          "
                          style="display: none"
                          accept="application/pdf"
                          [readOnly]="!update"
                        />
                      </a>
                      <span *ngIf="uploadStatus.licensesLeave">
                        (Uploaded)
                      </span>
                      <button
                        *ngIf="uploadStatus.licensesLeave"
                        type="button"
                        class="btn btn-dark btn-sm btn-update"
                        (click)="
                          removeFile(
                            'licensesLeave',
                            'licenses',
                            'availability'
                          )
                        "
                      >
                        X
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- evaluation -->
              <div class="row" *ngIf="step == 4">
                <div class="col-12">
                  <h4 class="title">Evaluation</h4>
                </div>
                <div class="row row_data" formGroupName="evaluation">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="scheduled"
                        >Scheduled</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="scheduled"
                        formControlName="scheduled"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="lastEvaluation"
                        >Last evaluation</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="lastEvaluation"
                        formControlName="lastEvaluation"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="nextEvaluation"
                        >Next evaluation</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="nextEvaluation"
                        formControlName="nextEvaluation"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="evaluator"
                        >Evaluator</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="evaluator"
                        formControlName="evaluator"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="score"
                        >Score</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="score"
                        formControlName="score"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="achievements"
                        >Achievements</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="achievements"
                        formControlName="achievements"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="areasImprovement"
                        >Areas of improvement</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="areasImprovement"
                        formControlName="areasImprovement"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="comments"
                        >Comments</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="comments"
                        formControlName="comments"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="activeGoals"
                        >Active goals</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="activeGoals"
                        formControlName="activeGoals"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="completedGoals"
                        >Completed goals</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="completedGoals"
                        formControlName="completedGoals"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="alerts"
                        >Alerts</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="alerts"
                        formControlName="alerts"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="metrics"
                        >Metrics</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="metrics"
                        formControlName="metrics"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- salary -->
              <div class="row" *ngIf="step == 5">
                <div class="col-12">
                  <h4 class="title">Salary</h4>
                </div>
                <div class="row row_data" formGroupName="salary">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="currentSalary"
                        >Current salary or rate</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="currentSalary"
                        formControlName="currentSalary"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="bonuses"
                        >Bonuses</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="bonuses"
                        formControlName="bonuses"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="increaseDate"
                        >Increase date</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="increaseDate"
                        formControlName="increaseDate"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="previousSalary"
                        >Previous salary</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="previousSalary"
                        formControlName="previousSalary"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="newSalary"
                        >New salary</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="newSalary"
                        formControlName="newSalary"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="authorizedBy"
                        >Authorized by</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="authorizedBy"
                        formControlName="authorizedBy"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="reason"
                        >Reason</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="reason"
                        formControlName="reason"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="comments"
                        >Comments</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="comments"
                        formControlName="comments"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid || isLoading"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>

              <div class="clearfix"></div>

              <!-- <div class="row mt-5">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="comments"
                      >Comments</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="comments"
                      formControlName="comments"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
              </div> -->
            </form>
            <!-- <button (click)="pru()">pru</button> -->

            <!-- Modal imgs-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModalImg }"
              style="background-color: rgba(0, 0, 0, 0.5)"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header modal-close">
                    <button
                      type="button"
                      class="btn btn-link btn-sm btn-close"
                      (click)="closeModalImg()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img [src]="imgModal" class="modal--imgs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="card-body">
              <form [formGroup]="form_two">
                <div class="row mt-5">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="comments"
                        >Comments</label
                      >
                      <textarea
                        type="text"
                        class="form-control"
                        id="comments"
                        formControlName="comments"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
            </div> -->
        </div>
      </div>
      <!-- <div class="col-md-4">
          <div class="card card-profile">
            <div class="card-avatar"></div>
            <div class="card-body">
              <h6 class="card-category text-gray">User profile</h6>
              <h4 class="card-title">
                {{ form.get("firstname")?.value }}
                {{ form.get("lastname")?.value }}
              </h4>
              <p class="card-description">
                  Aquí puedes editar los datos del usuario. Los cambios se
                  reflejarán en el sistema.
                </p>
              <a href="#pablo" class="btn btn-rose btn-round">Ver perfil</a>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</div>
